<template>
  <div>
    <Head title="Urlaub und Ferien im Spreewald" />
    <h1>Ferienwohnung Vogelschar</h1>
    <section class="pt-4 lg:px-16">
      <fade-image class="rounded-2xl shadow-lg shadow-gray-500" src="https://cdn.ferienwohnung-vogelschar.de/rs,s:1280/fewovs_haus_01a.jpg" width="1280" height="960" />
      <div class="pt-7">
        <p>Willkommen auf unserer Webseite.</p>
        <p>Wir bieten Ihnen eine modern eingerichtete und komplett ausgestattete 136m² große Wohnung. Die Wohnung ist ideal für eine Großfamilie oder zwei Familien, die sich kennen, aber auch Monteure sind willkommen.</p>
        <p>Es gibt 4 Schlafzimmer im Dachgeschoss, 3 Zimmer mit Doppelbett und 1 Zimmer mit zwei Einzelbetten. In zwei Zimmern wäre Platz für eine Aufbettung mit Kinderreisebett oder Gästebett möglich. Des Weiteren sind die Zimmer je mit einem Kleiderschrank, einer Kommode, einem Flachbildfernseher, Tisch und Stuhl ausgestattet. In der Etage sind zwei Bäder vorhanden, eins mit Dusche, das andere mit Badewanne und Waschmaschine.</p>
        <p>Im Erdgeschoss befindet sich das Wohn- und Esszimmer. Mit einer Couch zum Relaxen. Ein großer Tisch lädt zum gemeinsamen Beisammensein ein! Die Küche ist mit Elektroherd, Backofen, Kühl-/Gefrierkombination, Geschirrspüler, Mikrowelle, Kaffeemaschine, Wasserkocher und allem was man so braucht eingerichtet. In der Etage befindet sich noch ein kleines Gästebad mit Dusche. Bettwäsche und Handtücher auf Anfrage. Kostenloses WLAN.</p>
      </div>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FadeImage from '@/Shared/FadeImage'

import 'vue-silentbox/dist/style.css'

export default {
  components: {
    Head,
    FadeImage,
  },
  layout: Layout,
}
</script>
